export const SHIPMENTS_GRID_SEND_SHIPMENT_NOTIFICATION = 'SHIPMENTS_GRID_SEND_SHIPMENT_NOTIFICATION';
export const sendShipmentNotification = (fulfillmentIds) => {
  return {
    type: SHIPMENTS_GRID_SEND_SHIPMENT_NOTIFICATION,
    fulfillmentIds,
  };
};

export const SHIPMENTS_GRID_REFRESH_TRACKING = 'SHIPMENTS_GRID_REFRESH_TRACKING';
export const refreshTracking = (fulfillmentIds = []) => ({
  type: SHIPMENTS_GRID_REFRESH_TRACKING,
  fulfillmentIds,
});

export const SHIPMENTS_GRID_NOTIFY_MARKETPLACE = 'SHIPMENTS_GRID_NOTIFY_MARKETPLACE';
export const notifyMarketplace = (fulfillmentIds) => ({
  type: SHIPMENTS_GRID_NOTIFY_MARKETPLACE,
  fulfillmentIds,
});

export const SHIPMENTS_GRID_NOTIFY_MARKETPLACE_SUCCESS = 'SHIPMENTS_GRID_NOTIFY_MARKETPLACE_SUCCESS';
export const notifyMarketplaceSuccess = () => ({
  type: SHIPMENTS_GRID_NOTIFY_MARKETPLACE_SUCCESS,
});

export const SHIPMENTS_GRID_NOTIFY_MARKETPLACE_FAILURE = 'SHIPMENTS_GRID_NOTIFY_MARKETPLACE_FAILURE';
export const notifyMarketplaceFailure = (errors) => ({
  type: SHIPMENTS_GRID_NOTIFY_MARKETPLACE_FAILURE,
  errors,
});
